export const isManualPriceItem = (item: any): boolean => parseFloat(item?.imputed_value) > 0 || !!item?.changed_by_brand

export const getManualUnitPrice = (item: any): number => {
  const imputed = parseFloat(item?.imputed_value)
  if (imputed > 0) return imputed

  const quantity = Number(item?.quantity) || 0
  const amount = Number(item?.amount) || 0
  return quantity > 0 ? Number((amount / quantity).toFixed(2)) : Number(item?.unitPrice) || 0
}
